import React, { Fragment } from "react";
import { IGridHeader } from "../../../Interfaces/Grid/IGridHeader";
import RowLoader from "./RowLoader";

type props = {
  rows: number;
  headers: IGridHeader[];
  loadHeader: boolean;
  isGridAction: boolean;
};

export default function GridLoader(props: props): React.JSX.Element {
  const { rows, headers, isGridAction } = props;

  return (
    <Fragment>
      <RowLoader isGridAction={isGridAction} headers={headers} rows={rows} />
    </Fragment>
  );
}
